import { Component } from '@angular/core';
import {
  AlertContainer,
  Button,
  Icon,
  ModalAdapter,
} from '@malirang/front-share';

@Component({
  selector: 'app-password-confirm',
  templateUrl: './password-confirm.alert.html',
  imports: [Button, AlertContainer, Icon],
})
export class PasswordConfirmAlert extends ModalAdapter {}
